import script from "./createOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./createOrder.vue?vue&type=script&setup=true&lang=js"

import "./createOrder.vue?vue&type=style&index=0&id=36702696&lang=css"
import "./createOrder.vue?vue&type=style&index=1&id=36702696&lang=scss&scoped=true"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36702696"]])

export default __exports__